export default "__VITE_ASSET__72628157__"